import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";

type TextCaptionProps = {
  children: React.ReactNode;
};
export default function TextCaption({ children }: TextCaptionProps) {
  return (
    <Box component="span" sx={{ color: grey[700] }}>
      {children}
    </Box>
  );
}
